import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_hu83wawdag: FaireCollectionEntity = {
  token: "pbc_hu83wawdag",
  type: "collection",
  name: "Western 🤠🤠",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5fae9c5ee5fb4d3c043bd538016c7c45d76785c151892db60d824f110038db55.jpeg",
  itemCount: 43,
  description: "Saddle up for Fall with our newest collection, yeehaw!",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:37.822Z",
    importedBy: "entity-db-import-collections",
  },
};
